// Eskom PARCC — browser download glue (the only DOM-touching part of exports).
//
// Kept deliberately thin and separate from the pure builders: a builder produces
// a string / WorkBook, and these helpers push it to the browser as a file via a
// Blob + a temporary anchor. The object URL is revoked after the click so we do
// not leak it. Not unit-tested (DOM/binary); the row/string data is tested in
// the builders.
import * as XLSX from 'xlsx';

/**
 * Trigger a browser download of `text` as a file named `filename`, with the
 * given MIME type. Creates a Blob + a transient `<a download>` and clicks it,
 * then revokes the object URL.
 */
export function downloadText(filename: string, text: string, mime: string): void {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/**
 * Trigger a browser download of an XLSX WorkBook as `filename`. Delegates to
 * `XLSX.writeFile`, which builds the binary workbook and saves it via the same
 * anchor mechanism internally.
 */
export function downloadWorkbook(filename: string, workbook: XLSX.WorkBook): void {
  XLSX.writeFile(workbook, filename);
}
